import {
    $get,
    $post
} from '@/utils/http'
//清风论坛
export default {
    //一联课堂
    getClassroom(params) {
        return $post('/portal/forum/ylClassRoom/listArticle', params)
    },
    //一联课堂详情页
    getClassroomDetail(params) {
        return $post('/portal/forum/ylClassRoom/getArticleById', params)
    },
    geteducation(params) {
        return $post('/portal/forum/warning/listArticle', params)
    },
    //学习他人
    getoutside(params) {
        return $post('/portal/forum/learningOthers/listArticle', params)
    },
    //
    getarmed (params) {
        return $post('/portal/forum/armYouSelf/listArticle', params)
    },
    //学习他人详情
    getStudyDetail (params) {
        return $post('/portal/forum/learningOthers/getArticleById', params)
    },
    //武装自己详情
    getArmodDetail (params) {
        return $post('/portal/forum/armYouSelf/getArticleById', params)
    },
    //示警教育详情
    getEducationDetail (params) {
        return $post('/portal/forum/warning/getArticleById', params)
    },
}
